import { render, staticRenderFns } from "./DeviceDetailTabs.vue?vue&type=template&id=0d483801&scoped=true&"
import script from "./DeviceDetailTabs.vue?vue&type=script&lang=js&"
export * from "./DeviceDetailTabs.vue?vue&type=script&lang=js&"
import style0 from "./DeviceDetailTabs.vue?vue&type=style&index=0&id=0d483801&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d483801",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VAlert,VProgressLinear,VTab,VTabItem,VTabs})
